import styled from 'styled-components';

export const ContributeStyled = styled.div`
  margin-top: 130px;
  margin-bottom: 130px;
  .container {
    display: flex;
    flex-direction: column;
    padding: 0 20px;
    position: relative;
    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      margin-top: 50px;
    }
  }
  @media (min-width: 992px) {
    margin-bottom: 210px;
  }
`;

export const Card = styled.div`
  box-sizing: border-box;
  display: block;
  position: relative;
  margin-left: -184%;
  border-radius: 20px;
  color: var(--white);
  background: var(--pink);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  padding: 32px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    height: 408px;
    width: 552px;
    padding: 84px 96px;
    margin-left: 10%;
    font-size: 24px;
    line-height: 40px;
  }
  @media (min-width: 992px) {
    margin-left: -13%;
  }
`;

export const LeftColumn = styled.div`
  .social {
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    a {
      display: flex;
      align-items: center;
      > span {
        color: var(--blue);
        font-family: Rubik;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
        margin-left: 16px;
      }
      img {
        height: 48px;
        width: 48px;
        &:nth-of-type(2) {
          display: none;
        }
        @media (min-width: 992px) {
          height: 40px;
          width: 40px;
        }
      }
      &:hover {
        > span {
          color: var(--lblue);
        }
        img {
          &:nth-of-type(1) {
            display: none;
          }
          &:nth-of-type(2) {
            display: inline;
          }
        }
      }
      &:not(:last-of-type) {
        margin-bottom: 16px;
      }
    }
  }
  ${Card} {
    width: 100%;
    margin-left: unset;
  }
  @media (min-width: 992px) {
    max-width: 456px;
    margin-right: 312px;
    ${Card} {
      display: none;
    }
  }
`;
export const Title = styled.h1`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  @media (min-width: 992px) {
    font-size: 56px;
    letter-spacing: -1px;
    line-height: 64px;
    width: 446px;
  }
`;

export const Text = styled.p`
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 30px;
  &:not(:last-of-type) {
    margin-bottom: 34px;
  }
  @media (min-width: 992px) {
    margin-top: 50px;
  }
`;

export const TextBlue = styled.p`
  box-sizing: border-box;
  color: var(--blue);
  font-family: Rubik;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 24px;
  margin-bottom: 41px;
  @media (min-width: 768px) {
    margin-top: 41px;
    font-size: 24px;
    line-height: 32px;
  }
`;

export const RightColumn = styled.div`
  position: relative;
  box-sizing: border-box;
  height: 664px;
  width: 128px;
  border-radius: 40px 0 0 40px;
  left: 70%;
  display: none;
  align-items: center;
  img {
    display: none;
    position: absolute;
    width: 100%;
    height: 760px;
    max-width: 516px;
    object-fit: cover;
    border-radius: 20px;
    @media (min-width: 992px) {
      display: inline;
    }
  }
  @media (min-width: 992px) {
    display: flex;
    height: 760px;
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -80%;
    margin-right: -50vw;
  }
  @media (min-width: 1024px) {
    margin-left: -60%;
  }
  @media (min-width: 1440px) {
    margin-left: -50%;
  }
  @media (min-width: 1920px) {
    margin-left: -25%;
  }
`;
